// Shared MUI v5 building blocks of the full-page login screens
import MDButton from "components/MDButton";

// Translucent white card with rounded corners
export const loginCardSx = {
	backgroundColor: "rgba(255, 255, 255, 0.7)",
	borderRadius: "10px",
	boxShadow: "none",
	mb: "80px"
};

// Plain dark grey text link that turns red on hover
export function ForgotPasswordButton({ children, ...props }) {
	return (
		<MDButton
			variant="text"
			{...props}
			sx={{
				color: "#444041",
				fontSize: "16px",
				fontWeight: 400,
				textTransform: "none",
				mb: 1,
				"&:hover": { color: "red", backgroundColor: "transparent" }
			}}
		>
			{children}
		</MDButton>
	);
}

// Full-width primary submit button
export function SubmitButton({ children, ...props }) {
	return (
		<MDButton
			type="submit"
			variant="gradient"
			color="primary"
			size="large"
			fullWidth
			{...props}
			sx={{ height: "50px", textTransform: "none" }}
		>
			{children}
		</MDButton>
	);
}
